import branchCollectionBaseValidator from './branchCollection';

export default branchCollectionBaseValidator;
